import React from 'react';

const LogoPreview = ({ src, alt, height = 100, maxWidth = 320 }) => (
	<div
		className="image-upload-preview-frame"
		style={{
			width: '100%',
			maxWidth,
			height,
			background: '#E7EAF2',
			border: '1px solid #E7EAF2',
			borderRadius: 8,
			padding: 14,
			boxSizing: 'border-box',
			overflow: 'hidden',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		}}
	>
		{src && (
			<img
				src={src}
				alt={alt || 'CFS Logo preview'}
				style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', display: 'block' }}
			/>
		)}
	</div>
);

export default LogoPreview;
